<template>
  <div id="app_content" class="reserved" v-if="isMounted">
    <div class="container-articles">
      <div class="product-jumbo">

        <!--        <img-->
        <!--          :src="-->
        <!--            url(-->
        <!--              '/media/prodotti-gruppi/' +-->
        <!--                prodotti[0].cod_macrofamiglia +-->
        <!--                '-' +-->
        <!--                prodotti[0].cod_famiglia +-->
        <!--                '-' +-->
        <!--                prodotti[0].cod_categoria +-->
        <!--                '-' +-->
        <!--                prodotti[0].color.codice +-->
        <!--                '.jpg'-->
        <!--            )-->
        <!--          "-->
        <!--          alt="img product"-->
        <!--        />-->
        <image-elm
            :elm="prodotti"
        />
        <div class="product-title">
          <p class="categoria">
            <strong>
              <cod-elm :elm=prodotti></cod-elm>
            </strong>
          </p>
          <p class="microfamiglia">
            {{ prodotti.family.descrizione }}
          </p>

          <p class="descrizione">
            {{ prodotti.des_estesa }}

          </p>

        </div>
      </div>
      <hr/>

<!--      <div class="product-details" v-if="prodotti" >-->
<!--        <div class="titolo col-md-2 d-flex order-0">-->
<!--          <span>{{ trans.get("b2b.article.profile") }}</span>-->
<!--          <div  class="profilo">-->
<!--            <img v-if="!imageError" @error="imageError = true" :src="url('/storage/media/icons/svg/profili/' + prodotti.cod_famiglia.toLowerCase() + '.png' )" alt="profilo">-->
<!--          </div>-->

<!--        </div>-->

<!--        <div class="specifiche col-md-5 order-2 order-sm-1">-->
<!--          <div class="titolo">{{ trans.get("b2b.article.specs") }}</div>-->
<!--          <div class="lista-spec">-->
<!--            <ul-->
<!--                v-for="genspec in prodotti.general_datasheet"-->
<!--                v-if="prodotti.general_datasheet[0].cod_tipo === '100'"-->
<!--            >-->
<!--              <li-->
<!--                  v-if="-->
<!--                  genspec.id_ref_etichetta === '100-8' ||-->
<!--                  genspec.id_ref_etichetta === '100-9'-->
<!--                "-->
<!--              >-->
<!--                <etichetta-->
<!--                    class="etichetta-desc"-->
<!--                    :etichetta="genspec.id_ref_etichetta"-->
<!--                />-->
<!--                <span class="contenuto">{{ genspec.contenuto }}</span>-->
<!--              </li>-->
<!--            </ul>-->
<!--            <ul-->
<!--                v-for="genspec in prodotti.general_datasheet"-->
<!--                v-if="prodotti.general_datasheet[0].cod_tipo === '200'"-->
<!--            >-->
<!--              <li-->
<!--                  v-if="-->
<!--                  genspec.id_ref_etichetta === '200-8' ||-->
<!--                  genspec.id_ref_etichetta === '200-9'-->
<!--                "-->
<!--              >-->
<!--                <etichetta-->
<!--                    class="etichetta-desc"-->
<!--                    :etichetta="genspec.id_ref_etichetta"-->
<!--                />-->
<!--                <span class="contenuto">{{ genspec.contenuto }}</span>-->
<!--              </li>-->
<!--            </ul>-->
<!--            <ul>-->
<!--              <li>-->
<!--                <span class="etichetta-desc">Colore</span>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="c-frizione col-md-5 order-1 order-sm-2">-->
<!--          <div class="titolo">{{ trans.get("b2b.article.friction.coeff") }}</div>-->
<!--          <div class="lista-spec">-->
<!--            <ul-->
<!--                v-for="genspec in prodotti.general_datasheet"-->
<!--                v-if="prodotti.general_datasheet[0].cod_tipo === '100'"-->
<!--            >-->
<!--              <li-->
<!--                  v-if="-->
<!--                  genspec.id_ref_etichetta === '100-10' ||-->
<!--                  genspec.id_ref_etichetta === '100-11' ||-->
<!--                  genspec.id_ref_etichetta === '100-12'-->
<!--                "-->
<!--              >-->
<!--                <etichetta-->
<!--                    class="etichetta-desc"-->
<!--                    :etichetta="genspec.id_ref_etichetta"-->
<!--                />-->
<!--                <span class="contenuto">{{ genspec.contenuto }}</span>-->
<!--              </li>-->
<!--            </ul>-->
<!--            <ul-->
<!--                v-for="genspec in prodotti.general_datasheet"-->
<!--                v-if="prodotti.general_datasheet[0].cod_tipo === '200'"-->
<!--            >-->
<!--              <li-->
<!--                  v-if="-->
<!--                  genspec.id_ref_etichetta === '200-10' ||-->
<!--                  genspec.id_ref_etichetta === '200-11' ||-->
<!--                  genspec.id_ref_etichetta === '200-12'-->
<!--                "-->
<!--              >-->
<!--                <etichetta-->
<!--                    class="etichetta-desc"-->
<!--                    :etichetta="genspec.id_ref_etichetta"-->
<!--                />-->
<!--                <span class="contenuto">{{ genspec.contenuto }}</span>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <h2>{{ trans.get("b2b.article.select-product") }}</h2>
      <div class="selezione-prodotto">
        <!-- <b-loading :is-full-page="false" v-model="isLoading"></b-loading> -->
        <div
            class="heading"
            v-if="
            prodotti.datasheet[0] &&
            prodotti.datasheet[0].cod_tipo === '100'
          "
        >
          <span>{{ trans.get("b2b.article.prod-table-head.article_code") }}</span>
          <span class="diametro">{{ trans.get("diameter") }}</span>
          <span class="peso">{{ trans.get("b2b.article.prod-table-head.weight") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.pretension") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.traction") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.max-load") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.min-diameter") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.packaging-length") }}</span>
        </div>
        <div
            class="heading"
            v-if="
            prodotti.datasheet[0] &&
            prodotti.datasheet[0].cod_tipo === '200'
          "
        >
          <span>{{ trans.get("b2b.article.prod-table-head.article_code") }}</span>
          <span class="diametro">{{ trans.get("b2b.article.prod-table-head.section") }}</span>
          <span class="peso">{{ trans.get("b2b.article.prod-table-head.weight") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.pretension") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.traction") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.max-load") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.min-diameter") }}</span>
          <span>{{ trans.get("b2b.article.prod-table-head.packaging-length") }}</span>
        </div>
        <div
            class="prodotti"

            v-if="isMounted"
        >
          <single_art_card
              v-if="currentUser"
              class="single-art-card"
              :cod_art="prodotti.cod_art"
              :des_art="prodotti.des_art"
              :datasheet="prodotti.datasheet"
              :qtaimballo="
              prodotti.qta_per_imballo > 0 ? prodotti.qta_per_imballo : 1
            "
              :currentUser="currentUser"
              :currentRole="currentRole"
              :unita_misura="prodotti.unita_misura"
              @loaded="watchLoaded"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import etichetta from "./etichetta";
import single_art_card from "./single-art-card";

export default {
  name: "prodotti-uncat",
  components: {
    etichetta,
    single_art_card,
  },
  data: function () {
    return {
      isMounted: false,
      isloaded: false,
      prodotti: null,
      currentEtichetta: null,
      // currentUser: null,
      // currentRole: null,
      isLoading: false,
      imageError: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.nav.user.cod_cli_for
    },
    currentRole() {
      return this.$store.state.nav.user.id_ruolo
    }
  },
  mounted() {
    this.getArticles();
    //this.getCurrentUser();
  },
  methods: {
    watchLoaded: function (index) {
      if (index === this.prodotti.length - 1) {
        this.isLoading = false;
      }
    },
    getCurrentUser: function () {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-current-user",
      })
          .then((res) => {
            //console.log(res.data)
            this.currentUser = res.data.user;
            this.currentRole = res.data.role;
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    getArticles: function () {
      this.isLoading = true;
      let pathname = window.location.pathname.split("/");

      let slug = pathname[pathname.length - 1];

      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          slug: slug,
          type: "articles-uncat",
        },
      })
          .then((res) => {
            this.prodotti = res.data.family;
            //console.log(this.prodotti)
            this.isMounted = true;
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.reserved {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .container-articles {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    padding: 0 10px;

    h2 {
      font-size: 21px;
      margin-top: 100px;
      margin-bottom: 30px;
    }

    .product-jumbo {
      background-color: #f5f5f5;
      display: flex;
      justify-content: center;
      position: relative;
      img {
        width: 460px;
        height: 330px;
      }

      .product-title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 50%;
        margin-left: auto;
        position: absolute;
        right: 0;
        @media (max-width: 576px){
          width: 100%;
        }
        @media (max-width: 576px) {
          .categoria {
            display: flex;
            width: 100%;
            justify-content: center;
          }
        }
        .descrizione,
        .colore {
          text-transform: lowercase;

          &:first-letter {
            text-transform: uppercase;
          }
        }

        .descrizione, .categoria {
          font-size: 32px;
        }
      }
    }

    hr {
      background-color: #979797;
    }
    @media (max-width: 576px) {
      h2 {
        text-align: center;
      }
    }
    .product-details {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .titolo {
        font-size: 19px;
        width: 50%; //width: auto;
        flex-direction: row; //flex-direction: column;
        .profilo {
          height: 110px;
          img {
            margin-left: -15px;
            width: 70%;
          }
        }
      }

      .specifiche,
      .c-frizione {
        .titolo {
          font-size: 19px;
          margin-bottom: 36px;
        }

        .lista-spec {
          font-size: 15px;

          li {
            display: flex;

            .contenuto {
              margin-left: auto;
            }

            .contenuto-colore {
              margin-left: auto;
              text-transform: lowercase;

              &:first-letter {
                text-transform: uppercase;
              }
            }
          }
        }
      }

      .specifiche {
        width: 100%;
      }

      .c-frizione {
        width: 50%;
      }
    }

    .selezione-prodotto {
      position: relative;
      margin-bottom: 50px;
      .heading {
        display: none;
        font-size: 14px;
        margin-top: 50px;
        margin-bottom: 40px;
        padding-left: 50px;
        flex-direction: column;

        span {
          display: inline-block;
          width: calc(100% / 7);
          text-transform: capitalize;

          &.diametro,
          &.peso {
            width: calc(100% / 12);
          }
        }
      }

      .prodotti {
        .single-article-card {
          margin-bottom: 15px;
        }
      }
    }
  }
}

@media (min-width: 576px) {
  .reserved {
    .container-articles {
      .product-jumbo {
        position: initial;

        .product-title {
          position: initial;
        }
      }

      .product-details {
        flex-wrap: nowrap;

        .titolo {
          width: auto;
          flex-direction: column;
        }

        .specifiche {
          width: calc(100% / 3);
        }

        .c-frizione {
          width: calc(100% / 4);
        }
      }
    }
  }
  .reserved .container-articles .selezione-prodotto .heading {
    display: flex;
    flex-direction: row;
  }

}

@media (min-width: 1200px) {
  .reserved {
    .container-articles {
      width: 1200px;
      padding: 0;
    }
  }
}
</style>
